import { useState } from 'react'

export default function VerdictTicker({ verdicts }) {
  const [isPaused, setIsPaused] = useState(false)

  const formatTime = (timestamp) => {
    const diff = Date.now() - timestamp
    const hours = Math.floor(diff / (1000 * 60 * 60))
    if (hours < 1) {
      const minutes = Math.floor(diff / 60000)
      return `${minutes}m`
    }
    return `${hours}h`
  }

  // Duplicate verdicts for seamless scroll
  const tickerItems = [...verdicts, ...verdicts]

  if (verdicts.length === 0) {
    return (
      <div className="verdict-ticker">
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100%',
          color: 'var(--text-muted)',
          fontSize: 'var(--text-sm)'
        }}>
          No recent verdicts
        </div>
      </div>
    )
  }

  return (
    <div
      className="verdict-ticker"
      onMouseEnter={() => setIsPaused(true)}
      onMouseLeave={() => setIsPaused(false)}
    >
      <div
        className="ticker-track"
        style={{
          animationPlayState: isPaused ? 'paused' : 'running',
          animationDuration: `${verdicts.length * 8}s`
        }}
      >
        {tickerItems.map((verdict, index) => (
          <div key={`${verdict.ticker}-${index}`} className="ticker-item">
            <span className="ticker-symbol">{verdict.ticker}</span>
            <span className={`ticker-direction ${verdict.direction.toLowerCase()}`}>
              {verdict.direction}
            </span>
            <span className="ticker-confidence">{verdict.confidence}%</span>
            <span className="ticker-time">({formatTime(verdict.timestamp)})</span>
          </div>
        ))}
      </div>
    </div>
  )
}
